export default __webpack_public_path__ + "static/media/example-thumbnail.112f9e1f.png";